import { render, staticRenderFns } from "./AdultContentSwitcher.vue?vue&type=template&id=211fe1e5&scoped=true&"
import script from "./AdultContentSwitcher.vue?vue&type=script&lang=js&"
export * from "./AdultContentSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AdultContentSwitcher.vue?vue&type=style&index=0&id=211fe1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211fe1e5",
  null
  
)

export default component.exports